import ContactTypes from './contact.types';
import UserTypes from '../user/user.types';
import CallTypes from '../call/call.types';
import ContactState, { DPAResult } from './contact.state';
import AnyAction from 'store/anyActions';
import { secondsFrom } from 'utils';
import { mergeAttributesIntoContact, removeAttributesFromContact } from './contact.utils';

// eslint-disable-next-line
const testContact = {
    phoneNumber: '07811187708',
    ID: '',
    customer: { ID: '', phoneNumber: '' },
    DPA: {
        result: DPAResult['failed'], // 'failed' | 'no-check'
        agentCheck: {
            label: 'Agent check',
            passed: false,
        },
        passesRequired: 1,
        checks: [
            {
                label: 'National Insurance number',
                passed: true,
            },
            {
                label: 'Postcode',
                passed: false,
            },
            {
                label: 'Account number',
                passed: null,
            },
        ],
    },
};

export default function (state: ContactState | null = null, action: AnyAction): ContactState | null {
    switch (action.type) {
        case CallTypes.INCOMING_CALL:
        case CallTypes.CALLBACK_CALL:
            return action.payload.contact;
        case ContactTypes.SET_CONTACT:
            return action.payload ? { ...action.payload } : null;
        case ContactTypes.UPDATE_CONTACT:
            return state ? { ...state, ...action.payload } : null;
        case ContactTypes.UPDATE_CONTACT_ATTRIBUTES:
            if (!state) return state;
            return mergeAttributesIntoContact(state, action.payload.attributes);
        case ContactTypes.REMOVE_CONTACT_ATTRIBUTES:
            if (!state) return state;
            return removeAttributesFromContact(state, action.payload.attributes);
        case ContactTypes.CUSTOMER_UPDATED:
            return { ...state!, customer: { ...state!.customer!, ...action.payload } };
        case CallTypes.OUTBOUND_CALL:
            return { ...state!, ...action.payload.contact };
        case CallTypes.MAKE_CALL:
            return null;
        case CallTypes.CONNECTION_STARTED:
            if (!state) return state;
            return {
                ...state,
                connectedToAgentTimestamp: state.connectedToAgentTimestamp || Date.now(),
            };
        case CallTypes.CALL_ENDED:
            if (!state) return state;
            return {
                ...state,
                agentInteractionDuration:
                    state.agentInteractionDuration ||
                    secondsFrom(state.connectedToAgentTimestamp || state.initiationTimestamp),
                disconnectTimestamp: Date.now(),
            };
        case ContactTypes.UPDATE_DPA_RESULT:
            if (!state || !state.DPA) return state;
            return {
                ...state!,
                DPA: {
                    ...state!.DPA,
                    result: action.payload,
                },
            };
        case ContactTypes.UPDATE_DPA:
            if (!state || !state.DPA) return state;
            return {
                ...state!,
                DPA: {
                    ...state!.DPA,
                    checks: state!.DPA!.checks.map((check: any, i: number) => {
                        if (check.label === action.payload.label) return action.payload;
                        else return check;
                    }),
                },
            };
        case ContactTypes.UPDATE_AGENT_DPA:
            if (!state || !state.DPA) return state;
            return {
                ...state!,
                DPA: {
                    ...state!.DPA,
                    agentCheck: action.payload,
                    result: action.payload.passed ? DPAResult['agent-overall-passed'] : DPAResult['failed'],
                },
            };
        case ContactTypes.PARK_CALL_CONTACT:
            return {
                ...state!,
                parkBay: action.payload,
            };
        case ContactTypes.UPDATE_ACW_ATTRIBUTES: {
            if (!action.payload.ID) return state;
            return {
                ...state!,
                acwAttributes: action.payload.acwAttributes,
            };
        }
        case UserTypes.USER_AVAILABLE:
        case ContactTypes.CLEAR_CONTACT:
            return null;
        case UserTypes.LOGOUT:
            return null;
        default:
            return state;
    }
}
